export default "__VITE_ASSET__BvpH8Sd8__"